/* eslint-disable no-unused-vars */
import {Power1} from 'gsap';

const cheap = document.querySelector('.chapter__cheap svg');

const randomInteger = (min, max) => {
	const rand = min - 0.5 + Math.random() * (max - min + 1);

	return Math.round(rand);
};

const hideDots = (node, callback) => {
	const dots = node.querySelectorAll('.dot');

	gsap.set(dots, {
		onComplete() {
			if (callback) {
				callback(node);
			}
		},
		fill: 'rgba(255, 255, 255, 0.3)',
	});
};

const reset = (node = cheap) => {
	if (!node) {
		return;
	}

	const lines = node.querySelectorAll('.line, .progress-bar');

	if (!lines.length) {
		return;
	}

	hideDots(node);

	lines.forEach((element) => {
		const path = element.getTotalLength();

		gsap.set(element, {
			strokeDashoffset: path,
			strokeDasharray: `${path}, ${path}`,
		});
	});
};

const startDots = (node) => {
	const tl = gsap.timeline();
	const dots = node.querySelectorAll('.dot');
	const length = dots.length - 1;
	const arr = [];

	let prevcnt;

	for (let index = 0; index < 10; index++) {
		const cnt = randomInteger(1, length);

		if (prevcnt !== cnt) {
			const element = dots[cnt];
			prevcnt = cnt;

			arr.push(element);
		}
	}

	tl.to(arr, {
		onComplete() {
			hideDots(node, startDots);
		},
		ease: Power1.linear,
		stagger: 0.085,
		fill: '#FFFFFF',
	});
};

const startAnimeProgressLine = (node, time = 1) => {
	const parent = node.querySelectorAll('.progress-lines');

	parent.forEach((element) => {
		const status = element.querySelectorAll('.progress-bar');
		const progress = element.querySelectorAll('.progress');
		const tmProgress = gsap.timeline({paused: true});
		const tm = gsap.timeline({paused: true});

		if (progress.length === 0) {
			return;
		}

		tmProgress.to(progress, {
			onStart() {
				tm.play();
			},
			onReverseComplete() {
				tmProgress.play();
			},
			duration: 0.35,
			ease: Power1.easeInOut,
			fill: '#2796EE',
		});

		tm.to(status, {
			onComplete() {
				tm.reverse();
			},
			onReverseComplete() {
				tmProgress.reverse();
			},
			duration: 3.5,
			ease: Power1.easeInOut,
			strokeDashoffset: 0,
		}, 0.2);

		tmProgress.play();
	});
};

const startAnimeLine = (node, time = 1) => {
	const lines = node.querySelectorAll('.line');

	lines.forEach((element) => {
		const tl = gsap.timeline();
		const cnt = randomInteger(0, 1.5);

		tl.to(element, {
			onComplete() {
				tl.reverse();
			},
			onReverseComplete() {
				tl.play();
			},
			duration: 3.5,
			ease: Power1.easeInOut,
			strokeDashoffset: 0,
			alpha: 1,
		}, cnt);
	});
};

const animatioтScheme = (parent) => {
	console.log('init Anim')
	const main = parent.querySelector('.chapter__cheap svg');

	startAnimeLine(main);
	startAnimeProgressLine(main);
	startDots(main);
};

reset(cheap);

export {animatioтScheme, startAnimeProgressLine};
